import React from 'react';
import T from 'prop-types';
import { AppItemMobile, AppPlaceholderMobile } from './AppsListItem';

const placeholder = [1, 2, 3, 4, 5];

const AppsListMobile = ({ apps, onAppRemove, onPlaceholderClick }) => (
  <div className="app-selection-apps-list">
    {apps.map(app => (
      <AppItemMobile
        key={app.ref_no}
        app={app}
        onAppRemove={onAppRemove}
      />
    ))}
    {placeholder.slice(apps.length).map((item, i) => (
      <AppPlaceholderMobile
        key={item}
        onPlaceholderClick={onPlaceholderClick}
        showSelected={i === 0}
      />
    ))}
  </div>
);

AppsListMobile.propTypes = {
  apps: T.array,
  onAppRemove: T.func,
  onPlaceholderClick: T.func,
};

export default AppsListMobile;
